require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/es6.array.species.js
// module id = 168
// module chunks = 0